import { Box, Typography } from "@material-ui/core";
import CommonBreadcrumb from "src/components/Breadcrumb/CssBreadcrumb";
import PoolSelector from "src/components/Selector/PoolSelector";
import AuthorizationWrapper from "src/components/Wrapper/AuthorizationWrapper";
import FilterTool from "./FilterTool";
import TransactionLog from "./TransactionLog";

export default function TransactionMonitoring() {
  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
        <CommonBreadcrumb
          config={[{ text: "analytics" }, { text: "transaction monitoring", link: "/transaction-monitoring" }]}
        />
        <PoolSelector rootUrl="/transaction-monitoring" />
      </Box>
      <AuthorizationWrapper isOnlyAdmin={true}>
        <Box>
          <Typography variant="h4">Transaction Log</Typography>
          <Typography>
            Bảng theo dõi lịch sử giao dịch của các địa chỉ ví trong lending pool. Chỉ có admin mới có quyền xem.
          </Typography>
          <FilterTool />
          <Box mt={2}>
            <TransactionLog />
          </Box>
        </Box>
      </AuthorizationWrapper>
    </>
  );
}
